import { s24 } from '@ardoq/design-tokens';
import { SidebarMenuSection } from '@ardoq/sidebar-menu';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Header3 } from '@ardoq/typography';
import { Stack } from '@ardoq/layout';

const Padding = styled(Stack).attrs({ gap: 'medium' })`
  width: 100%;
  height: 100%;
  padding: ${s24};
  padding-top: 0;
`;

type ContentWrapperProps = {
  title?: string;
};

export const ContentWrapper = ({
  title,
  children,
}: PropsWithChildren<ContentWrapperProps>) => {
  return (
    <SidebarMenuSection isCollapsible={false}>
      <Padding>
        {title && <Header3>{title}</Header3>}
        {children}
      </Padding>
    </SidebarMenuSection>
  );
};
